import styled from '@emotion/styled';

/* ── types ── */

interface MatterportBlock1Props {
	url: string;
	index?: number;
}

/* ── styled components ── */

const Wrapper = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	padding: 1.5rem;
	max-width: 1536px;
	margin-left: auto;
	margin-right: auto;
	@media (min-width: 768px) {
		height: 100vh;
	}
`;

const Title = styled.div`
	text-transform: uppercase;
	font-weight: 500;
	font-size: 1.5rem;
	line-height: 2rem;
	letter-spacing: 0.3em;
	text-align: center;
	padding-top: 2rem;
	padding-bottom: 2rem;
	@media (min-width: 768px) {
		font-size: 2.25rem;
		line-height: 2.5rem;
	}
`;

const TourIframe = styled.iframe`
	flex: 1;
	position: relative;
	height: 1px;
`;

/* ── component ── */

export default function MatterportBlockEta({ url, index }: MatterportBlock1Props) {
	return (
		<Wrapper id={index == null ? 'tours' : undefined}>
			<Title>3D Tour</Title>
			<TourIframe src={url} allowFullScreen allow="xr-spatial-tracking" />
		</Wrapper>
	);
}
